export enum enumIsfCodeStep {
  IM = 'IM',
  CN = 'CN',
  BY = 'BY',
  ST = 'ST',
  SE = 'SE',
  MF = 'MF',
  CS = 'CS',
  LG = 'LG',
  SHIP = 'SHIP',
  HTS = 'HTS',
  SUM = 'SUM',
  RES = 'RES',
}
